import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import AppBarForLogin from "@/components/app-bar-for-main-login-pages/AppBarForLogin";
import SignUpForm from "@/components/signup/SignUpForm";
import { getUser } from '@/service/weexpertService';
import { Loader } from '@/components/ProtectedRoute';

export default function SignUpPage() {
  const navigate = useNavigate();
  
  // Check if user is already logged in
  const { data: userData, isLoading, isError } = useQuery({
    queryKey: ['userCheckSignUp'],
    queryFn: getUser,
    retry: false,
    refetchOnWindowFocus: false
  });
  
  useEffect(() => {
    // If user is successfully authenticated, redirect to main page
    if (userData && !isError) {
      navigate('/');
    }
  }, [userData, isError, navigate]);
  
  // Show loader while checking authentication
  if (isLoading) {
    return <Loader />;
  }
  
  // Show sign-up form only if user is not authenticated
  return <>
    <AppBarForLogin />
    <div className="pt-24">
      <SignUpForm />
    </div>
  </>
}
